<template>
    <div  class="nav-item dropdown show toggle-editor-icon" style="inset-inline-start:2%">
        <a :title="$t('Enable/Disable toolbar')" class="nav-item nav-link dropdown-toggle mr-md-2 icon-background-on-hover" @click="toggleEditorToolbar()" href="#" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" :style="isEditorToolbarOpen ? 'fill: #00bdbd;':'fill: #ddd'"><path d="M80 0v-160h800V0H80Zm140-280 210-560h100l210 560h-96l-50-144H368l-52 144h-96Zm176-224h168l-82-232h-4l-82 232Z"/></svg>
        </a>
     </div>
</template>

<script>
export default {
   name:"RichtexteditorToggleToolBar",
   data(){
      return {
          isEditorToolbarOpen: false
      }
   },
   methods:{
        toggleEditorToolbar(){
          if(this.isEditorToolbarOpen){
             this.isEditorToolbarOpen = false;
          }else{
             this.isEditorToolbarOpen = true;
          }
          this.$emit("toggleRichtextEditorToolbar",this.isEditorToolbarOpen);
       },
   },
}
</script>

<style>

</style>